import request from '@/utils/request'

export const userApi = {
  login: (data) => request.post('/auth/login', data),
  register: (data) => request.post('/auth/register', data),
  getUserInfo: () => request.get('/auth/me'),
  logout: () => request.post('/auth/logout'),
  updateUser: (data) => request.put('/auth/update', data)
}